import { CheckCallStatus } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentCheckCallReminderController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async sendReminderEmails(
    shipmentId: number,
    emails: string,
  ): Promise<CheckCallStatus> {
    const response = await this.http.post<CheckCallStatus>(
      `${shipmentId}/check-call/send`,
      { emails },
    );
    return new CheckCallStatus(response.data);
  }

  async getCheckCallReminderStatus(
    shipmentId: number,
  ): Promise<CheckCallStatus> {
    const response = await this.http.get<CheckCallStatus>(
      `/${shipmentId}/check-call`,
    );
    return new CheckCallStatus(response.data);
  }

  async cancelCheckCallReminders(shipmentId: number): Promise<CheckCallStatus> {
    const response = await this.http.post<CheckCallStatus>(
      `/${shipmentId}/check-call/cancel`,
    );
    return new CheckCallStatus(response.data);
  }
}
